import { Fragment } from "react";

export default function LoadingSpinner(props) {
  return (
    <div className="spinner-container">
      {props.text ? <div>{props.text}</div>: <Fragment></Fragment>}
      <div className="loading-spinner" />
    </div>
  );
}